import React from "react";

const Componentes = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiM2M1YjhmOWUtMThhOS00OWM0LTkwMGQtMzEwYjZiYzIzZGRkIiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9&pageName=ReportSection7ddbb29c4d334aa1a2e2" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default Componentes;
